const getSelectedUsersArray = (user, selectedUsers) => {
  if (user.checked) {
    return selectedUsers.filter((selectedUser) => user.number !== selectedUser.number)
  }
  return [...selectedUsers, { name: user.name, number: user.number }]
}

export default getSelectedUsersArray
